import { render, staticRenderFns } from "./AlphaDecayTunnelingViz.vue?vue&type=template&id=04af3769&scoped=true"
import script from "./AlphaDecayTunnelingViz.vue?vue&type=script&lang=js"
export * from "./AlphaDecayTunnelingViz.vue?vue&type=script&lang=js"
import style0 from "./AlphaDecayTunnelingViz.vue?vue&type=style&index=0&id=04af3769&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af3769",
  null
  
)

export default component.exports